"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TYPE_WEDGE = exports.TYPE_SLICE = exports.TYPE_SHELL = exports.TYPE_SECTION = exports.TYPE_POCKET = exports.TYPE_HEART = exports.TYPE_CAVITY = exports.TYPE_BOLT = void 0;
var _SVGDamagePreview = _interopRequireDefault(require("./SVGDamagePreview"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TYPE_HEART = exports.TYPE_HEART = 'HEART';
var TYPE_SHELL = exports.TYPE_SHELL = 'SHELL';
var TYPE_POCKET = exports.TYPE_POCKET = 'POCKET';
var TYPE_WEDGE = exports.TYPE_WEDGE = 'WEDGE';
var TYPE_SECTION = exports.TYPE_SECTION = 'SECTION';
var TYPE_SLICE = exports.TYPE_SLICE = 'SLICE';
var TYPE_BOLT = exports.TYPE_BOLT = 'BOLT';
var TYPE_CAVITY = exports.TYPE_CAVITY = 'CAVITY';
var ansiMap = {
  20: 4.5,
  25: 5,
  30: 5.5,
  35: 6
};
var SectionCalculator = /*#__PURE__*/function () {
  function SectionCalculator() {
    _classCallCheck(this, SectionCalculator);
    _defineProperty(this, "maxPixelY", void 0);
    _defineProperty(this, "maxPixelX", void 0);
    _defineProperty(this, "pixelWidthX", void 0);
    _defineProperty(this, "pixelWidthY", void 0);
    _defineProperty(this, "pixelArea", void 0);
    _defineProperty(this, "poleDiameter", void 0);
    _defineProperty(this, "pixelColor", []);
    _defineProperty(this, "damageOverlay", void 0);
    _defineProperty(this, "poleRadius", void 0);
    _defineProperty(this, "center", void 0);
    _defineProperty(this, "momentInertiaX", 0);
    _defineProperty(this, "momentInertiaY", 0);
    _defineProperty(this, "momentSlopeX", 0);
    _defineProperty(this, "momentSlopeY", 0);
    _defineProperty(this, "area", 0);
    _defineProperty(this, "damages", []);
    _defineProperty(this, "maxDx", 0);
    _defineProperty(this, "maxDy", 0);
    _defineProperty(this, "dx", 0);
    _defineProperty(this, "dy", 0);
    _defineProperty(this, "iBarX", 0);
    _defineProperty(this, "iBarY", 0);
    _defineProperty(this, "center", void 0);
    _defineProperty(this, "makePixelColor", function (colorArray, maxX, maxY) {
      for (var x = 0; x < maxX; x++) {
        colorArray[x] = [];
        colorArray[x].length = maxX;
        for (var y = 0; y < maxY; y++) colorArray[x][y] = 0;
      }
      return colorArray;
    });
    _defineProperty(this, "pythagorean", function (a, b) {
      return Math.round(Math.pow(Math.pow(a, 2) - Math.pow(b, 2), .5));
    });
    this.maxPixelX = 125;
    this.maxPixelY = 125;
    this.pixelColor = this.makePixelColor([], this.maxPixelX, this.maxPixelY);
    this.damageOverlay = new _SVGDamagePreview["default"]();
    this.center = Math.floor(this.maxPixelX / 2) + 1;
  }
  _createClass(SectionCalculator, [{
    key: "__toRadians",
    value: function __toRadians(angle) {
      return (90 - angle) / 180 * Math.PI;
    }
  }, {
    key: "__toPositiveRadians",
    value: function __toPositiveRadians(angle) {
      var phi = this.__toRadians(angle);
      if (phi < 0) phi = phi + 6.2832;
      return phi;
    }
  }, {
    key: "__setupPixelArray",
    value: function __setupPixelArray(pixelColor) {
      var dx,
        dy,
        color1,
        pixelArray = _toConsumableArray(pixelColor);
      for (var x = 0; x <= Math.floor(this.maxPixelX / 2 - 1); x++) {
        for (var y = 0; y <= Math.floor(this.maxPixelY / 2 - 1); y++) {
          dx = (this.center - x + 1 / 2 - 1) * this.pixelWidthX;
          dy = (this.center - y + 1 / 2 - 1) * this.pixelWidthY;
          if (Math.pow(dx, 2) + Math.pow(dy, 2) >= Math.pow(this.poleRadius, 2)) {
            dx = (this.center - x - 1 / 2 - 1) * this.pixelWidthX;
            dy = (this.center - y - 1 / 2 - 1) * this.pixelWidthY;
            color1 = Math.pow(dx, 2) + Math.pow(dy, 2) >= Math.pow(this.poleRadius, 2) ? 2 : 1;
            pixelArray[x][y] = color1;
            pixelArray[this.maxPixelX - 1 - x][y] = color1;
            pixelArray[x][this.maxPixelY - 1 - y] = color1;
            pixelArray[this.maxPixelX - 1 - x][this.maxPixelY - 1 - y] = color1;
          }
        }
      }
      return {
        pixelColor: pixelArray,
        dx: dx,
        dy: dy,
        color1: color1
      };
    }
  }, {
    key: "__calculateShell",
    value: function __calculateShell(_ref, pixelColor) {
      var damageDepth = _ref.damageDepth;
      var x1, x2, y1, y2;
      var centerRadius = (this.poleRadius - damageDepth) / this.poleRadius * (this.maxPixelX / 2);
      for (var i = 0; i <= this.center - 1; i += .1) {
        y1 = Math.round(this.center - i);
        y2 = this.maxPixelX - y1 + 1;
        x1 = i < centerRadius ? this.pythagorean(centerRadius, i) : x1 = 0;
        x2 = this.pythagorean(this.center, i);
        if (x2 >= this.center) x2 = this.center - 1;
        for (var j = Math.round(x1); j <= Math.round(x2); j++) {
          pixelColor[this.center + j - 1][Math.round(y1) - 1] = 3;
          pixelColor[this.center - j - 1][Math.round(y1) - 1] = 3;
          pixelColor[this.center + j - 1][Math.round(y2) - 1] = 3;
          pixelColor[this.center - j - 1][Math.round(y2) - 1] = 3;
        }
      }
      for (var _i = 0; _i <= 2 * Math.PI; _i = _i + 0.001) {
        x1 = centerRadius * Math.cos(_i) + this.maxPixelX / 2 + 1 / 2;
        y1 = centerRadius * Math.sin(_i) + this.maxPixelY / 2 + .5;
        pixelColor[Math.round(x1) - 1][Math.round(y1) - 1] = 4;
        x1 = Math.floor(this.maxPixelX / 2) * Math.cos(_i) + this.center;
        y1 = Math.floor(this.maxPixelX / 2) * Math.sin(_i) + this.center;
        pixelColor[Math.round(x1) - 1][Math.round(y1) - 1] = 4;
      }
    }
  }, {
    key: "__calculateHeart",
    value: function __calculateHeart(_ref2, pixelColor) {
      var shellThickness = _ref2.shellThickness;
      var x1, y1;
      var centerRadius = (this.poleDiameter - 2 * shellThickness) / this.poleDiameter * (this.maxPixelX / 2);
      for (var i = 0; i <= Math.PI / 2; i += 0.001) {
        pixelColor[Math.round(centerRadius * Math.cos(i) + this.center) - 1][Math.round(centerRadius * Math.sin(i) + this.center) - 1] = 4;
        pixelColor[Math.round(this.center - centerRadius * Math.cos(i)) - 1][Math.round(centerRadius * Math.sin(i) + this.center) - 1] = 4;
        pixelColor[Math.round(centerRadius * Math.cos(i) + this.center) - 1][Math.round(this.center - centerRadius * Math.sin(i)) - 1] = 4;
      }
      for (var y = 0; y <= centerRadius; y += .1) {
        y1 = Math.round(y);
        x1 = this.pythagorean(centerRadius, y);
        for (var _y = Math.round(this.center - x1); _y <= Math.round(this.center + x1); _y++) {
          pixelColor[_y - 1][Math.round(this.center + y1) - 1] = 3;
          pixelColor[_y - 1][Math.round(this.center - y1) - 1] = 3;
        }
      }
    }
  }, {
    key: "__calculatePocket",
    value: function __calculatePocket(_ref3, pixelColor) {
      var angleToMinShell = _ref3.angleToMinShell,
        pocketDiameter = _ref3.pocketDiameter,
        shellThickness = _ref3.shellThickness;
      var xpics, ypics, r, theta, y1, x1;
      var centerRadius = pocketDiameter / this.poleDiameter * (this.maxPixelY / 2);
      r = this.poleRadius - shellThickness - pocketDiameter / 2;
      r = r / this.poleRadius * this.maxPixelY / 2;
      theta = this.__toRadians(angleToMinShell);
      xpics = Math.cos(theta) * r + this.center;
      ypics = this.center - Math.sin(theta) * r;
      for (var i = 0; i <= Math.PI / 2; i += 0.001) {
        pixelColor[Math.round(centerRadius * Math.cos(i) + xpics - 1)][Math.round(centerRadius * Math.sin(i) + ypics - 1)] = 3;
        pixelColor[Math.round(centerRadius * Math.cos(i) + xpics - 1)][Math.round(ypics - centerRadius * Math.sin(i) - 1)] = 3;
        pixelColor[Math.round(xpics - centerRadius * Math.cos(i) - 1)][Math.round(centerRadius * Math.sin(i) + ypics - 1)] = 3;
        pixelColor[Math.round(xpics - centerRadius * Math.cos(i) - 1)][Math.round(ypics - centerRadius * Math.sin(i) - 1)] = 3;
      }
      for (var _i2 = 0; _i2 <= centerRadius; _i2 += 0.1) {
        y1 = Math.round(_i2);
        x1 = this.pythagorean(centerRadius, _i2);
        for (var xj = Math.round(xpics - x1); xj <= Math.round(xpics + x1); xj++) {
          pixelColor[xj - 1][Math.round(ypics + y1 - 1)] = 3;
          pixelColor[xj - 1][Math.round(ypics - y1 - 1)] = 3;
        }
      }
    }
  }, {
    key: "__calculateWedge",
    value: function __calculateWedge(_ref4, pixelColor) {
      var angleToDamage = _ref4.angleToDamage,
        circumferenceMissing = _ref4.circumferenceMissing,
        depthMissing = _ref4.depthMissing;
      var phi, angleWidth, startAngle, theta, stopAngle, increment, x1, y1;
      phi = this.__toPositiveRadians(angleToDamage);
      var centerRadius = (this.poleRadius - depthMissing) / this.poleRadius * this.maxPixelX / 2;
      theta = circumferenceMissing / depthMissing / 2;
      for (var i = centerRadius; i <= this.maxPixelX / 2; i += 0.501) {
        angleWidth = (i - centerRadius) * theta / i * 2;
        startAngle = phi + angleWidth / 2;
        stopAngle = phi - angleWidth / 2;
        if (startAngle < 0) startAngle = startAngle + 6.2832;
        if (stopAngle > 6.2832) stopAngle = stopAngle - 6.2832;
        increment = startAngle < stopAngle ? 0.01 : -0.01;
        var continueLoop = function continueLoop(j, stopAngle) {
          return increment > 0 ? j <= stopAngle : j >= stopAngle;
        };
        for (var j = startAngle; continueLoop(j, stopAngle); j += increment) {
          x1 = i * Math.cos(j) + this.center;
          y1 = this.center - i * Math.sin(j);
          pixelColor[Math.round(x1 - 1)][Math.round(y1 - 1)] = 2;
        }
      }
    }
  }, {
    key: "__calculateSection",
    value: function __calculateSection(_ref5, pixelColor) {
      var angleToOpening = _ref5.angleToOpening,
        depthMissing = _ref5.depthMissing,
        circumferenceMissing = _ref5.circumferenceMissing,
        shellThickness = _ref5.shellThickness;
      var phi, angleWidth, startAngle, cshells, stopAngle, increment, x1, y1;
      phi = this.__toPositiveRadians(angleToOpening);
      angleWidth = circumferenceMissing / this.poleRadius;
      startAngle = phi + angleWidth / 2;
      stopAngle = phi - angleWidth / 2;
      cshells = (this.poleRadius - shellThickness) / this.poleRadius * this.maxPixelX / 2;
      var centerRadius = (this.poleRadius - depthMissing) / this.poleRadius * this.maxPixelX / 2;
      if (startAngle < 0) startAngle = startAngle + 6.2832;
      increment = startAngle < stopAngle ? 0.01 : -0.01;
      var continueLoop = function continueLoop(j, stopAngle) {
        return increment > 0 ? j <= stopAngle : j >= stopAngle;
      };
      for (var i = centerRadius; i <= cshells; i += 0.501) {
        for (var j = startAngle; continueLoop(j, stopAngle); j += increment) {
          x1 = i * Math.cos(j) + this.center;
          y1 = this.center - i * Math.sin(j);
          pixelColor[Math.round(x1 - 1)][Math.round(y1 - 1)] = 2; // a possibly important difference here. if big issue look at vb to compare
        }
      }
    }
  }, {
    key: "__calculateSlice",
    value: function __calculateSlice(_ref6, pixelColor) {
      var angleToDamage = _ref6.angleToDamage,
        depthMissing = _ref6.depthMissing,
        widthMissing = _ref6.widthMissing;
      var l, depth, chord, phi, startAngle, theta, stopAngle, x, x1, y1, x2, x3, y2, y3; // I refactored this one a little: it used to take in either 1, or 2 as the second parameter. 1 is depth and 2 is width
      depth = depthMissing;
      phi = this.__toPositiveRadians(angleToDamage);
      if (widthMissing) {
        chord = widthMissing;
        depth = this.poleRadius - Math.pow(Math.pow(this.poleRadius, 2) - Math.pow(chord / 2, 2), 0.5);
      }
      var centerRadius = (this.poleRadius - depth) / this.poleRadius * this.maxPixelX / 2;
      for (var i = centerRadius; i <= this.maxPixelX / 2; i += 0.5) {
        if (i === 0) i = 1;
        x = Math.pow(Math.pow(this.maxPixelX / 2, 2) - Math.pow(i, 2), 0.5);
        startAngle = phi + Math.atan(x / i);
        stopAngle = phi - Math.atan(x / i);
        x2 = (Math.cos(startAngle) + 1) * (this.maxPixelX / 2 + 0.5);
        x3 = (Math.cos(stopAngle) + 1) * (this.maxPixelX / 2 + 0.5);
        y2 = (1 - Math.sin(startAngle)) * (this.maxPixelX / 2 + 0.5);
        y3 = (1 - Math.sin(stopAngle)) * (this.maxPixelX / 2 + 0.5);
        theta = x2 !== x3 ? Math.atan(Math.abs((y3 - y2) / (x2 - x3))) : 1.5708;
        l = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2));
        // change all md values to just more desciptive
        for (var j = 1; j <= Math.round(l); j++) {
          if (x2 < x3 && y2 < y3) {
            x1 = x2 + j * Math.cos(theta);
            y1 = y2 + j * Math.sin(theta);
          }
          if (x2 < x3 && y2 > y3) {
            x1 = x2 + j * Math.cos(theta);
            y1 = y2 - j * Math.sin(theta);
          }
          if (x2 > x3 && y2 > y3) {
            x1 = x3 + j * Math.cos(theta);
            y1 = y3 + j * Math.sin(theta);
          }
          if (x2 > x3 && y2 < y3) {
            x1 = x3 + j * Math.cos(theta);
            y1 = y3 - j * Math.sin(theta);
          }
          if (x2 == x3) {
            x1 = x2;
            if (y2 < y3) y1 = y2 + j;else y1 = y3 + j;
          }
          if (y2 == y3) {
            y1 = y2;
            if (x2 < x3) x1 = x2 + j;else x1 = x3 + j;
          }
          if (x1 > this.maxPixelX) x1 = this.maxPixelX;
          if (y1 > this.maxPixelY) y1 = this.maxPixelY;
          if (x1 < 1) x1 = 1;
          if (y1 < 1) y1 = 1;
          pixelColor[Math.round(x1 - 1)][Math.round(y1 - 1)] = 5;
        }
      }
    }
  }, {
    key: "__calculateBolt",
    value: function __calculateBolt(_ref7, pixelColor) {
      var angleToOpening = _ref7.angleToOpening,
        holeDiameter = _ref7.holeDiameter;
      var phi, startAngle, theta, stopAngle, x4, x1, y1, x2, x3, y2, y3, xInt, yInt, increment;
      phi = this.__toPositiveRadians(angleToOpening);
      x3 = holeDiameter / 2 / (this.poleDiameter / 2);
      theta = Math.atan(x3 / Math.sqrt(-x3 * x3 + 1));
      startAngle = phi + theta;
      stopAngle = phi - theta;
      for (x4 = theta; x4 >= -Math.abs(theta); x4 += -0.0005) {
        startAngle = phi + x4;
        stopAngle = phi - x4;
        x1 = this.maxPixelX / 2 + this.maxPixelX / 2 * Math.cos(startAngle);
        x2 = this.maxPixelX / 2 - this.maxPixelX / 2 * Math.cos(stopAngle);
        y1 = this.maxPixelX / 2 - this.maxPixelX / 2 * Math.sin(startAngle);
        y2 = this.maxPixelX / 2 + this.maxPixelX / 2 * Math.sin(stopAngle);
        var continueLoop = function continueLoop(a, b) {
          return increment > 0 ? a <= b : a >= b;
        };
        if (Math.abs(y2 - y1) >= Math.abs(x2 - x1)) {
          if (y2 > y1) increment = 0.5;else increment = -0.5;
          for (y3 = y1; continueLoop(y3, y2); y3 += increment) {
            x3 = x2 - (y2 - y3) * (x2 - x1) / (y2 - y1);
            var xx = void 0,
              yy = void 0;
            xx = Math.round(x3 - 1);
            yy = Math.round(y3 - 1);
            if (xx < 0) xx = 0;
            if (yy < 0) yy = 0;
            pixelColor[xx][yy] = 3;
          }
        } else {
          if (x2 > x1) increment = 0.5;else increment = -0.5;
          for (x3 = x1; continueLoop(x3, x2); x3 += increment) {
            y3 = y2 - (y2 - y1) * (x2 - x3) / (x2 - x1);
            xInt = Math.round(x3 - 1);
            yInt = Math.round(y3 - 1);
            if (xInt >= 0 && xInt <= 149 && yInt >= 0 && yInt <= 149) {
              pixelColor[Math.round(x3 - 1)][Math.round(y3 - 1)] = 3;
            }
          }
        }
      }
    }
  }, {
    key: "__calculateCavity",
    value: function __calculateCavity(_ref8, pixelColor) {
      var angleToOpening = _ref8.angleToOpening,
        circumferenceMissing = _ref8.circumferenceMissing,
        shellThicknessAtOpening = _ref8.shellThicknessAtOpening,
        nestDiameter = _ref8.nestDiameter;
      var ypics, xpics, phi, startAngle, theta, stopAngle, x1, y1, angleWidth, r, increment;
      var centerRadius = nestDiameter / this.poleDiameter * (this.maxPixelY / 2);
      r = this.poleRadius - shellThicknessAtOpening - nestDiameter / 2;
      r = r / this.poleRadius * this.maxPixelY / 2;
      theta = this.__toRadians(angleToOpening);
      xpics = Math.cos(theta) * r + this.center;
      ypics = this.center - Math.sin(theta) * r;
      for (var i = 0; i <= Math.PI / 2; i += 0.001) {
        pixelColor[Math.round(centerRadius * Math.cos(i) + xpics - 1)][Math.round(centerRadius * Math.sin(i) + ypics - 1)] = 3;
        pixelColor[Math.round(centerRadius * Math.cos(i) + xpics - 1)][Math.round(ypics - centerRadius * Math.sin(i) - 1)] = 3;
        pixelColor[Math.round(xpics - centerRadius * Math.cos(i) - 1)][Math.round(centerRadius * Math.sin(i) + ypics - 1)] = 3;
        pixelColor[Math.round(xpics - centerRadius * Math.cos(i) - 1)][Math.round(ypics - centerRadius * Math.sin(i) - 1)] = 3;
      }
      for (var _i3 = 0; _i3 <= centerRadius; _i3 += 0.1) {
        y1 = Math.round(_i3);
        x1 = this.pythagorean(centerRadius, _i3);
        for (var j = Math.round(xpics - x1); j <= Math.round(xpics + x1); j++) {
          pixelColor[j - 1][Math.round(ypics + y1 - 1)] = 3;
          pixelColor[j - 1][Math.round(ypics - y1 - 1)] = 3;
        }
      }
      phi = this.__toPositiveRadians(angleToOpening);
      angleWidth = circumferenceMissing / this.poleRadius;
      startAngle = phi + angleWidth / 2;
      stopAngle = phi - angleWidth / 2;
      if (startAngle < 0) startAngle = startAngle + 6.2832;
      centerRadius = (this.poleRadius - shellThicknessAtOpening) / this.poleRadius * this.maxPixelX / 2;
      increment = startAngle < stopAngle ? 0.01 : -0.01;
      var continueLoop = function continueLoop(j, stopAngle) {
        return increment > 0 ? j <= stopAngle : j >= stopAngle;
      };
      for (var _i4 = centerRadius; _i4 <= this.maxPixelX / 2; _i4 += 0.501) {
        for (var _j = startAngle; continueLoop(_j, stopAngle); _j += increment) {
          x1 = _i4 * Math.cos(_j) + this.center;
          y1 = this.center - _i4 * Math.sin(_j);
          pixelColor[Math.round(x1 - 1)][Math.round(y1 - 1)] = 2;
        }
      }
    }
  }, {
    key: "__calculateBarValues",
    value: function __calculateBarValues(pixelColorArray) {
      var xBar = 0,
        yBar = 0,
        pixelOn,
        pixelMultiplier = 0,
        pixelArea = this.pixelWidthX * this.pixelWidthY;
      var sumAyBar = 0,
        sumAy = 0,
        sumAxBar = 0,
        sumAx = 0;
      var pixelColor = _toConsumableArray(pixelColorArray);
      var iit = 0;
      var iif = 0;
      for (var x = 0; x < this.maxPixelX; x++) {
        for (var y = 0; y < this.maxPixelY; y++) {
          if (pixelColor[x][y] === 0) {
            pixelOn = false;
            iif = iif + 1;
          } else {
            pixelOn = true;
            iit = iit + 1;
          }
          pixelMultiplier = 1;
          if (pixelOn === false) {
            if (y > 1 && y < this.maxPixelY - 2 && x > 1 && x < this.maxPixelX - 2) {
              if (pixelColor[x][y - 1] !== 0 && pixelColor[x][y + 1] !== 0) {
                pixelOn = true;
                iit = iit + 1;
              }
              if (pixelColor[x - 1][y] !== 0 && pixelColor[x + 1][y] !== 0) {
                pixelOn = true;
                iit = iit + 1;
              }
              if (pixelColor[x][y - 2] !== 0 && pixelColor[x][y + 2] !== 0) {
                pixelOn = true;
                iit = iit + 1;
              }
              if (pixelColor[x - 2][y] !== 0 && pixelColor[x + 2][y] !== 0) {
                pixelOn = true;
                iit = iit + 1;
              }
            }
          }
          if (y > 0 && y < this.maxPixelY - 1 && pixelColor[x][y] !== 0) {
            if (pixelColor[x][y - 1] === 0 && pixelColor[x][y + 1] !== 0) {
              pixelMultiplier = 0.85;
              pixelOn = false;
              iif = iif + 1;
            }
            if (pixelColor[x][y - 1] !== 0 && pixelColor[x][y + 1] === 0) {
              pixelMultiplier = 0.85;
              pixelOn = false;
              iif = iif + 1;
            }
          }
          if (x > 0 && x < this.maxPixelX - 1 && pixelColor[x][y] !== 0) {
            if (pixelColor[x - 1][y] === 0 && pixelColor[x + 1][y] !== 0) {
              pixelMultiplier = 0.85;
              pixelOn = false;
              iif = iif + 1;
            }
            if (pixelColor[x - 1][y] !== 0 && pixelColor[x + 1][y] === 0) {
              pixelMultiplier = 0.85;
              pixelOn = false;
              iif = iif + 1;
            }
          }
          if (!pixelOn) {
            sumAx = sumAx + pixelArea * pixelMultiplier;
            xBar = (x + 1 - (this.center + 1)) * this.pixelWidthX;
            sumAxBar = sumAxBar + xBar * pixelArea * pixelMultiplier;
            sumAy = sumAy + pixelArea * pixelMultiplier;
            yBar = (y + 1 - (this.center + 1)) * this.pixelWidthY;
            sumAyBar = sumAyBar + yBar * pixelArea * pixelMultiplier;
            this.area = this.area + pixelArea * pixelMultiplier;
          }
        }
      }
      xBar = sumAx > 0 ? sumAxBar / sumAx : 0;
      yBar = sumAy > 0 ? sumAyBar / sumAy : 0;
      return {
        iit: iit,
        iif: iif,
        xBar: xBar,
        yBar: yBar,
        sumAy: sumAy,
        sumAx: sumAx,
        sumAyBar: sumAyBar,
        sumAxBar: sumAxBar
      };
    }
  }, {
    key: "__calculateMomentOfInertia",
    value: function __calculateMomentOfInertia(xBar, yBar) {
      var pixelOn,
        pixelMultiplier,
        a1 = 0,
        a2 = 0;
      for (var x = 0; x < this.maxPixelX; x++) {
        for (var y = 0; y < this.maxPixelY; y++) {
          pixelOn = this.pixelColor[x][y] == 0 ? false : true;
          pixelMultiplier = 1;
          if (y > 0 && y < this.maxPixelY - 1 && pixelOn === true) {
            if (this.pixelColor[x][y - 1] === 0 && this.pixelColor[x][y + 1] !== 0) {
              pixelMultiplier = 0.85;
              pixelOn = false;
            }
            if (this.pixelColor[x][y - 1] !== 0 && this.pixelColor[x][y + 1] === 0) {
              pixelMultiplier = 0.85;
              pixelOn = false;
            }
          }
          if (x > 0 && x < this.maxPixelX - 1 && pixelOn === true) {
            if (this.pixelColor[x - 1][y] === 0 && this.pixelColor[x + 1][y] !== 0) {
              pixelMultiplier = 0.85;
              pixelOn = false;
            }
            if (this.pixelColor[x - 1][y] !== 0 && this.pixelColor[x + 1][y] === 0) {
              pixelMultiplier = 0.85;
              pixelOn = false;
            }
          }
          if (pixelOn === false) {
            this.iBarX = Math.pow(this.pixelWidthX, 3) * this.pixelWidthY / 12 * pixelMultiplier;
            this.dx = (x + 1 - (this.center + 1)) * this.pixelWidthX - xBar;
            if (Math.abs(this.dx) > this.maxDx) this.maxDx = Math.abs(this.dx);
            if (this.dx > a1) a1 = this.dx;
            if (this.dx < a2) a2 = this.dx;
            this.momentInertiaX = this.momentInertiaX + this.iBarX + this.pixelArea * Math.pow(this.dx, 2) * pixelMultiplier;
            this.iBarY = Math.pow(this.pixelWidthY, 3) * this.pixelWidthX / 12 * pixelMultiplier;
            this.dy = (y + 1 - (this.center + 1)) * this.pixelWidthY - yBar;
            if (Math.abs(this.dy) > this.maxDy) this.maxDy = Math.abs(this.dy);
            this.momentInertiaY = this.momentInertiaY + this.iBarY + this.pixelArea * Math.pow(this.dy, 2) * pixelMultiplier;
          }
        }
      }
    }
  }, {
    key: "calculateLevel",
    value: function calculateLevel(_ref9) {
      var _this = this;
      var diameter = _ref9.diameter,
        damages = _ref9.damages,
        distanceFromGround = _ref9.distanceFromGround;
      this.damages = damages;
      this.poleDiameter = diameter;
      this.poleRadius = diameter / 2;
      this.pixelWidthX = this.poleDiameter / this.maxPixelX;
      this.pixelWidthY = this.poleDiameter / this.maxPixelY;
      this.pixelArea = this.pixelWidthX * this.pixelWidthY;
      var easyCalc = true;
      var maxShellRot = 0,
        maxShellThick = 0;
      this.damages.forEach(function (damage) {
        if (damage.type === TYPE_SHELL) {
          damage.damageDepth > maxShellRot ? maxShellRot = damage.damageDepth : easyCalc = false;
        } else if (damage.type === TYPE_HEART) {
          damage.shellThickness > maxShellThick ? maxShellThick = damage.shellThickness : easyCalc = false;
        } else {
          easyCalc = false;
        }
      });
      if (easyCalc) {
        var ig, ihr, ag, ahr;
        if (maxShellThick === 0) maxShellThick = this.poleDiameter / 2;
        ig = Math.pow(this.poleDiameter - maxShellRot * 2, 4);
        ihr = Math.pow(this.poleDiameter - maxShellThick * 2, 4);
        this.momentInertiaX = (ig - ihr) * Math.PI / 64;
        this.momentInertiaY = this.momentInertiaX;
        ag = Math.pow(this.poleDiameter - maxShellRot * 2, 2) * Math.PI / 4;
        ahr = Math.pow(this.poleDiameter - maxShellThick * 2, 2) * Math.PI / 4;
        this.area = ag - ahr;
        this.maxDx = this.poleDiameter / 2 - maxShellRot - this.pixelWidthX / 2;
        this.maxDy = this.poleDiameter / 2 - maxShellRot - this.pixelWidthY / 2;
      } else {
        var _this$__setupPixelArr = this.__setupPixelArray(this.pixelColor),
          dx = _this$__setupPixelArr.dx,
          dy = _this$__setupPixelArr.dy,
          pixelColor = _this$__setupPixelArr.pixelColor;
        this.pixelColor = pixelColor;
        this.dx = dx;
        this.dy = dy;
        this.damages.forEach(function (damage) {
          switch (damage.type) {
            case TYPE_SHELL:
              _this.__calculateShell(damage, _this.pixelColor);
              break;
            case TYPE_HEART:
              _this.__calculateHeart(damage, _this.pixelColor);
              break;
            case TYPE_POCKET:
              _this.__calculatePocket(damage, _this.pixelColor);
              break;
            case TYPE_WEDGE:
              _this.__calculateWedge(damage, _this.pixelColor);
              break;
            case TYPE_SECTION:
              _this.__calculateSection(damage, _this.pixelColor);
              break;
            case TYPE_SLICE:
              _this.__calculateSlice(damage, _this.pixelColor);
              break;
            case TYPE_BOLT:
              _this.__calculateBolt(damage, _this.pixelColor);
              break;
            case TYPE_CAVITY:
              _this.__calculateCavity(damage, _this.pixelColor);
              break;
            default:
              break;
          }
        });
        this.center = Math.floor(this.maxPixelX / 2);
        var _this$__calculateBarV = this.__calculateBarValues(this.pixelColor),
          xBar = _this$__calculateBarV.xBar,
          yBar = _this$__calculateBarV.yBar;
        this.__calculateMomentOfInertia(xBar, yBar);
      }
      this.damageOverlay.drawSection(1, {
        damages: this.damages,
        diameter: this.poleDiameter
      });
      this.maxDx = this.maxDx + this.pixelWidthX / 2;
      this.maxDy = this.maxDy + this.pixelWidthY / 2;
      this.poleRadius = this.poleDiameter / 20 - maxShellRot;
      this.momentSlopeX = this.momentInertiaX / this.maxDx;
      this.momentSlopeY = this.momentInertiaY / this.maxDy;
      return {
        momentSlopeX: this.momentSlopeX,
        momentSlopeY: this.momentSlopeY,
        momentInertiaX: this.momentInertiaX,
        momentInertiaY: this.momentInertiaY,
        area: this.area,
        svg: this.damageOverlay.getSvg(1)
      };
    }
  }]);
  return SectionCalculator;
}();
var _default = exports["default"] = SectionCalculator;